export default "__VITE_ASSET__hGxydlDs__"